import axiosInstance, { axiosPublic } from "../../api/axiosConfig";
import { getApiBaseUrl } from "../../baseUrl";
import { Vaga } from "../../../types";

// Busca as vagas ativas SEM exigir autenticação (página pública de divulgação).
// Usa axiosPublic para não passar pelo interceptor de 401 (que redireciona para login).
export async function buscarVagasPublicas(): Promise<Vaga[]> {
  const apiUrl = getApiBaseUrl();
  try {
    const response = await axiosPublic.get(`${apiUrl}/vagas/publicas`);

    // O backend retorna ApiResponse<List<VagaResponseDTO>> — desembrulho defensivo
    return Array.isArray(response.data)
      ? response.data
      : response.data?.data || [];
  } catch (error) {
    console.error("Erro ao buscar vagas públicas:", error);
    return [];
  }
}

export async function buscarVagas(apenasAtivas: boolean = true): Promise<Vaga[]> {
  const apiUrl = getApiBaseUrl();
  // Para prefeitura, pode buscar todas as vagas (ativas e inativas)
  // Para candidatos, buscar sempre vagas ativas
  const url = apenasAtivas ? `${apiUrl}/vagas?ativo=true` : `${apiUrl}/vagas`;
  const response = await axiosInstance.get(url);

  // O backend retorna ApiResponse<List<VagaResponseDTO>>
  if (response.data && response.data.success && response.data.data) {
    return response.data.data;
  }

  return response.data || [];
}
